import { useTranslation } from "react-i18next";

export function useDashboardSteps() {
  const { t } = useTranslation("tours");
  return [
    {
      target: '[data-testid="dash-hero"]',
      title: t("dashboard.step1.title"),
      content: t("dashboard.step1.content"),
    },
    {
      target: '[data-testid="dash-hero-status"]',
      title: t("dashboard.step2.title"),
      content: t("dashboard.step2.content"),
    },
    {
      target: '[data-testid="dash-hero-analyse-btn"]',
      title: t("dashboard.step3.title"),
      content: t("dashboard.step3.content"),
    },
  ];
}
